import React, { useRef } from 'react';
var VeltInlineCommentsSectionFilterDropdownContentListItem = function (props) {
    var defaultCondition = props.defaultCondition, filter = props.filter, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content-list-item", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, filter: filter }, children));
};
export default VeltInlineCommentsSectionFilterDropdownContentListItem;
